'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('./google-drive.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HS_logo_white = require('landing-pages/assets/HS_logo_white.svg');

var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);

var _googledrive_logo = require('landing-pages/assets/googledrive_logo.svg');

var _googledrive_logo2 = _interopRequireDefault(_googledrive_logo);

var _clouds_googledrive = require('landing-pages/assets/clouds_googledrive.svg');

var _clouds_googledrive2 = _interopRequireDefault(_clouds_googledrive);

var _overlay_left = require('landing-pages/assets/overlay_left.svg');

var _overlay_left2 = _interopRequireDefault(_overlay_left);

var _overlay_right = require('landing-pages/assets/overlay_right.svg');

var _overlay_right2 = _interopRequireDefault(_overlay_right);

var _signature_icon = require('landing-pages/assets/signature_icon.svg');

var _signature_icon2 = _interopRequireDefault(_signature_icon);

var _document_icon = require('landing-pages/assets/document_icon.svg');

var _document_icon2 = _interopRequireDefault(_document_icon);

var _security_icon = require('landing-pages/assets/security_icon.svg');

var _security_icon2 = _interopRequireDefault(_security_icon);

var _screenshot_googledrive = require('landing-pages/assets/screenshot_googledrive.png');

var _screenshot_googledrive2 = _interopRequireDefault(_screenshot_googledrive);

var _socialSection = require('landing-pages/components/common/social-section');

var _socialSection2 = _interopRequireDefault(_socialSection);

var _faqSection = require('landing-pages/components/common/faq-section');

var _faqSection2 = _interopRequireDefault(_faqSection);

var _howItWorksSection = require('landing-pages/components/common/how-it-works-section');

var _howItWorksSection2 = _interopRequireDefault(_howItWorksSection);

var _benefitsSection = require('landing-pages/components/common/benefits-section');

var _benefitsSection2 = _interopRequireDefault(_benefitsSection);

var _pricingCtaSection = require('landing-pages/components/common/pricing-cta-section');

var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);

var _ctaButton = require('landing-pages/components/common/cta-button');

var _ctaButton2 = _interopRequireDefault(_ctaButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function GoogleDrive(p) {
    // Google Drive constants
    var benefits = [{
        icon: _signature_icon2['default'],
        title: 'Sign documents from Google Drive',
        text: 'Prepare documents for signature in Google Drive with a few easy clicks — just choose whether to sign and download or send a signature request.'
    }, {
        icon: _document_icon2['default'],
        title: 'Access your Google Drive documents',
        text: 'Once you’ve linked your accounts, you can import documents from Google Drive on HelloSign.com.'
    }, {
        icon: _security_icon2['default'],
        title: 'Save copies of signed documents',
        text: 'Documents are stored both in Google Drive and in your HelloSign account.'
    }];
    var howItWorks = ['Connect your Google Drive and HelloSign accounts to start signing documents from within Google Drive. Then you’ll be able to sign or send any document in your drive folders.', 'On HelloSign.com, you’ll also be able to import documents stored in Google Drive.', 'All of the docs you send through the extension will show up in the documents view on HelloSign.com.'];
    var twitterLink = 'https://twitter.com/intent/tweet?original_referer=https%3a%2f%2fwww.hellosign.com%2fgoogldrive&ref_src=twsrc%5Etfw&text=Did%20you%20know%20%40HelloSign%20integrates%20with%20%40GoogleDrive%3F%20Sign%20documents%20directly%20from%20Google%20Drive.&tw_p=tweetbutton&url=https%3a%2f%2fwww.hellosign.com%2fgoogledrive%3futm_medium%3Ds2s%26utm_source%3Dtwitter';
    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/googledrive?utm_source=facebook%26utm_medium=s2s ';
    var linkedInLink = 'https://www.linkedin.com/cws/share?url=https%3a%2f%2fwww.hellosign.com%2fgoogledrive%3futm_medium%3Ds2s%26utm_source%3Dlinkedin&original_referer=https%3a%2f%2fwww.hellosign.com%2fgoogledrive&token=&isFramed=false&lang=en_US&_ts=1462214138386.6147&xd_origin_host=https%3A%2F%2Fwww.hellosign.com';
    var border = '2px solid #D7D7D7';

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations google-drive' },
        _react2['default'].createElement(IllustrationArea, p),
        _react2['default'].createElement(
            'div',
            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top', style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
            _react2['default'].createElement(_howItWorksSection2['default'], {
                image: _screenshot_googledrive2['default'],
                explanation: howItWorks }),
            _react2['default'].createElement(_socialSection2['default'], {
                title: 'Share with your networks!',
                twitterLink: twitterLink,
                facebookLink: facebookLink,
                linkedInLink: linkedInLink }),
            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/articles/205794528' }),
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom', style: { borderTop: border, fontWeight: 600 } })
        )
    );
}

function IllustrationArea(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'top row', style: { backgroundColor: '#AEDEDA' } },
        _react2['default'].createElement(
            'div',
            { className: 'top-content-container large-5 large-push-6 columns' },
            _react2['default'].createElement(
                'div',
                { className: 'hellosign-dropbox' },
                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
                _react2['default'].createElement(
                    'span',
                    { className: 'plus' },
                    '+'
                ),
                _react2['default'].createElement('img', { src: _googledrive_logo2['default'], alt: 'GoogleDrive Logo', className: 'dropbox-logo' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'title' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'Sign and send directly from Google Drive'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'subtitle' },
                _react2['default'].createElement(
                    'h2',
                    null,
                    'It\u2019s easy to add legally binding eSignatures to documents that are stored in your Google Drive with the HelloSign integration. You can sign and download a document or add fields for others to fill out and sign from within Google Drive.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'signup-button' },
                _react2['default'].createElement(_ctaButton2['default'], _extends({}, p, {
                    buttonText: 'Try it free' }))
            )
        ),
        _react2['default'].createElement(
            'div',
            { className: 'clouds-container large-5 large-pull-4 columns' },
            _react2['default'].createElement('img', { src: _clouds_googledrive2['default'], alt: 'cloud left' })
        ),
        _react2['default'].createElement('img', { src: _overlay_left2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud left', className: 'cloud-left' }),
        _react2['default'].createElement('img', { src: _overlay_right2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud right', className: 'cloud-right' })
    );
}

module.exports = GoogleDrive;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/google-drive.jsx
 ** module id = 1647
 ** module chunks = 0
 **/